import {Helmet} from 'react-helmet-async';

interface Props {
  pageTitle?: string;
}

const PageHelmet = ({pageTitle}: Props) => (
  <Helmet defaultTitle="Amica" titleTemplate="%s | Amica">
    <title>{pageTitle}</title>
  </Helmet>
);

export default PageHelmet;
